import Box from "@mui/material/Box";
import FormLayout from "../../../components/FormLayout";
import CustomButton from "../../../components/CustomButton";
import CommonCard from "./CommonCard";
import CreditBreakdownCard from "./CreditBreakdownCard";
import { HTTPRequestStatus } from "../../../utils/models";
import LineLoader from "../../../components/Loaders/LineLoader/LineLoader";
import { useSelector, useDispatch } from "react-redux";
import { toDollar } from "../../../utils/dataConverter";
import { useFinalBalanceContext } from "../FinalBalanceContainer";
import { push } from "redux-first-history";

const BalanceReview = () => {
  const dispatch = useDispatch();
  const { calculations } = useFinalBalanceContext();
  const { status } = useSelector((appState: any) => appState.payment);
  const {
    data: { collection_year },
  } = useSelector((appState: any) => appState.user);
  const summary = {
    title: `Your ${collection_year} Taxable Income`,
    cardDescription: "",
    options: {
      "Total Wages": calculations.total_wage_income,
      "Tax Exempt Wages": calculations.tax_exempt_wage_income,
      "Total Taxable Wages": calculations.total_wage_income - calculations.tax_exempt_wage_income,
      "Taxable Income from Self Employment":
        calculations.total_schedule_income_with_losses,
      "Other Taxable Income":
        calculations.total_other_income,
      "Total Taxable Income":
        calculations.total_taxable_income,
    },
  };
  // TODO use backend datapoint for total
  const taxBeforeCredits = {
    title: "Your Tax Before Credits",
    cardDescription:
      "Here’s the tax on that income before we consider any credits from tax witholding or prior tax payments you may have made.",
    options: {
      [`${toDollar(calculations.total_taxable_income)} x ${
        (calculations.tax_rate * 100)
      }%`]: calculations.tax_liability,
    },
  };

  return (
    <FormLayout
      title={"Tax Calculations"}
      subtitle={"Summary"}
      description={
        "LIME is finished calculating your return. Here's a summary of your taxable income, the tax due on that income, and the credits on your account. Select 'Next' once you've reviewed this summary."
      }
      className=""
    >
      {status === HTTPRequestStatus.Requesting && <LineLoader />}
      <Box className='card'>
        <CommonCard cardDetails={summary} />
      </Box>
      <Box className='card'>
        <CommonCard cardDetails={taxBeforeCredits} bold={[0]} />
      </Box>
      <Box className='card'>
        <CreditBreakdownCard calculations={calculations} />
      </Box>
      <div className='btn-container'>
        <CustomButton
          variant="outlined"
          disableElevation={false}
          label={"back"}
          onClick={() => dispatch(push('/upload/IRS1040'))}
          buttonSize='btn-lg'
        />
        <CustomButton
          variant="contained"
          disableElevation={true}
          label={"next"}
          type="submit"
          onClick={() => dispatch(push('/balance/review'))}
          buttonSize="btn-lg"
        />
      </div>
    </FormLayout>
  );
};

export default BalanceReview;
